import(/* webpackMode: "eager", webpackExports: ["ReviewsSection"] */ "/app/components/frontend/common/reviews-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AIMLMTools"] */ "/app/components/frontend/home/ai-mlm-tools.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogNewsSection"] */ "/app/components/frontend/home/blog-news.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandThemeSection"] */ "/app/components/frontend/home/brand-theme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactSection"] */ "/app/components/frontend/home/contact-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardOverview"] */ "/app/components/frontend/home/dashboard-overview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FlexibleMLMPlatform"] */ "/app/components/frontend/home/flexible-mlm-platform.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/app/components/frontend/home/home-faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeFeatures"] */ "/app/components/frontend/home/home-features.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/app/components/frontend/home/home-hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomemlmServices"] */ "/app/components/frontend/home/home-mlm-services.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeModules"] */ "/app/components/frontend/home/home-modules.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IndustrySolutions"] */ "/app/components/frontend/home/industry-solutions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MLMServices"] */ "/app/components/frontend/home/mlm-services.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileAppSupport"] */ "/app/components/frontend/home/mobile-app-support.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmartContractMLM"] */ "/app/components/frontend/home/smart-contract-mlm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Testimonials"] */ "/app/components/frontend/home/testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoSection"] */ "/app/components/frontend/home/video-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyMlmSoftware"] */ "/app/components/frontend/home/why-mlm-software.tsx");
